var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "no-results": _vm.objects === null || _vm.objects.length === 0,
        "results-card": _vm.objects && _vm.objects.length > 0
      }
    },
    [
      _vm.objects === null
        ? _c("span", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("GlobalSearchResultsInstruction")) +
                "\n  "
            )
          ])
        : _vm.objects.length === 0
        ? _c("span", [_vm._v("\n    " + _vm._s(_vm.$t("NoResults")) + "\n  ")])
        : _vm.objects.length > 0
        ? _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("span", { staticClass: "table-title" }, [
                _vm._v(_vm._s(_vm.$tc("Result", 2)))
              ]),
              _vm._v(" "),
              _c("Table", {
                style: { width: "100%" },
                attrs: {
                  loading: _vm.loading,
                  headers: _vm.headers,
                  items: _vm.objects,
                  emitRowClickBusEvent: true,
                  sortable: true,
                  "scroll-id": _vm.scrollId
                },
                on: {
                  onScrollBottom: _vm.onScrollBottom,
                  onScrollTop: _vm.onScrollTop,
                  sortClick: _vm.onSortClick
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64428573", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64428573","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchResults.vue
// module id = null
// module chunks = 